import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="radio-form-validation"
// Disables the submit button until all radio groups have a selection.
export default class extends Controller {
  static targets = ['radio', 'submit']

  connect () {
    this.checkAllSelected()
    this.radioTargets.forEach(radio => {
      radio.addEventListener('change', this.checkAllSelected.bind(this))
    })
  }

  checkAllSelected () {
    const itemIds = Array.from(new Set(this.radioTargets.map(r => r.name)))
    const allSelected = itemIds.every(name => this.element.querySelector(`input[name='${name}']:checked`))
    this.submitTarget.disabled = !allSelected
    if (allSelected) {
      this.submitTarget.classList.remove('opacity-50', 'pointer-events-none')
    } else {
      this.submitTarget.classList.add('opacity-50', 'pointer-events-none')
    }
  }
}
